import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import LanguageStyleWrapper from "./Language.style";

const LANGS = [
  { label: "English", value: "en", icon: "https://flagcdn.com/us.svg" },
  { label: "한국어", value: "ko", icon: "https://flagcdn.com/kr.svg" },
  { label: "Việt Nam", value: "vn", icon: "https://flagcdn.com/vn.svg" },
  { label: "中國", value: "cn", icon: "https://flagcdn.com/cn.svg" },
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18n.language);
  const selectorRef = useRef(null);

  useEffect(() => {
    setCurrentLang(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleChangeLang = (lang) => {
    i18n.changeLanguage(lang);
    setCurrentLang(lang);
    localStorage.removeItem("popupShow");
    setOpen(false);
  };

  return (
    <LanguageStyleWrapper>
      <div className="language-selector" ref={selectorRef}>
        <button
          className="language-button"
          onClick={() => setOpen((prev) => !prev)}
        >
          🌐
          <span className="language-label">
            {LANGS.find((l) => l.value === currentLang)?.label || "Language"}
          </span>
        </button>

        {open && (
          <div className="language-menu">
            {LANGS.map((lang) => (
              <button
                key={lang.value}
                className={`language-item ${
                  lang.value === currentLang ? "active" : ""
                }`}
                onClick={() => handleChangeLang(lang.value)}
              >
                <img src={lang.icon} alt={lang.label} />
                <span>{lang.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </LanguageStyleWrapper>
  );
}
